import { render, staticRenderFns } from "./TaskActs.vue?vue&type=template&id=1afa63de&scoped=true&"
import script from "./TaskActs.vue?vue&type=script&lang=js&"
export * from "./TaskActs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa63de",
  null
  
)

export default component.exports